var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagIconSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 8.66667H13.058C13.3663 8.66667 13.5205 8.66667 13.6085 8.60201C13.6853 8.54564 13.7343 8.45911 13.7431 8.36427C13.7533 8.25551 13.6739 8.1233 13.5153 7.85894L12.1646 5.60773C12.1047 5.50796 12.0748 5.45808 12.0631 5.40483C12.0528 5.35773 12.0528 5.30894 12.0631 5.26184C12.0748 5.20859 12.1047 5.1587 12.1646 5.05894L13.5153 2.80773C13.6739 2.54335 13.7533 2.41116 13.7431 2.3024C13.7343 2.20756 13.6853 2.12103 13.6085 2.06465C13.5205 2 13.3663 2 13.058 2H2.66663L2.66663 14",
    stroke: "#413F5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIconSmall);
export default __webpack_public_path__ + "static/media/FlagIconSmall.056bda64430b5e812b8c9fa50476867f.svg";
export { ForwardRef as ReactComponent };